import { CommonModule } from '@angular/common';
import { Component, computed,HostListener } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { IconsComponent } from 'src/app/shared/components/icons/icons.component';
import { AuthActions } from 'src/app/state/store/auth/auth.actions';
import { selectParent } from 'src/app/state/store/parent/parent.selectors';
import { selectUserPermission } from 'src/app/state/store/user/user.selectors';

@Component({
  selector: 'app-header',
  imports: [NgbDropdownModule, IconsComponent, CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  userData = this.store.selectSignal(selectUserPermission);
  selectedParentData = this.store.selectSignal(selectParent);

  userType = computed(() => this.userData()?.user_type || 'Super Admin'); // should be replcaed with roleName - Ajay
  username = computed(() => {
    const user = this.userData();
    return user ? `${user.first_name} ${user.last_name}` : 'HelpDesk User';
  });
  userImage = computed(
    () => this.userData()?.imageUrl ?? 'assets/images/user.png'
  );
  logoImage = computed(() => {
    return this.userData()?.user_type == 'user' ? this.selectedParentData()?.parent_client_logo || 'assets/images/login-logo.png' : 'assets/images/login-logo.png';
  });

  constructor(private readonly store: Store, private readonly router: Router) {}

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    const isCtrlOrMeta = event.ctrlKey || event.metaKey;
    const isDelete =
      event.code === 'Delete' ||
      event.key === 'Delete' ||
      event.key === 'Del' ||
      event.key === 'Backspace';
    const target = event.target as HTMLElement | null;
    const tag = target?.tagName?.toLowerCase();
    if (
      isCtrlOrMeta &&
      isDelete &&
      tag !== 'input' &&
      tag !== 'textarea' &&
      !target?.isContentEditable
    ) {
      event.preventDefault();
      this.router.navigate(['/profile/change-password']);
    }
  }

  onLogout(): void {
    this.store.dispatch(AuthActions.logout({}));
  }
}
